<template>
  <div id="previewClusters">
    <div class="o-modal">
      <div class="o-modal-content big">
        <div class="o-modal-header">
          <a
            @click="closeClusterPreview()"
            class="close clickable"
          ><i class="far fa-times"></i></a>
          <p class="lead">Cluster Preview</p>
        </div><!-- /.o-modal-header -->
        <!-- THE MAP PREVIEW -->
        <div id="map" class="map"></div>

        <div class="o-modal-footer">
          <div class="container">
            <div class="row">
              <div class="col-8">
                <button
                  @click="$store.commit('multivariate/setStateProperty', { property: 'pickFolder', value: true })"
                  class="btn btn-success mr-1 w-100"
                >
                  Save to Every.Farm
                </button>
              </div><!-- /.col-6 -->
              <div class="col-4">
                <button
                  @click="download()"
                  class="btn btn-primary mr-1 w-100"
                >
                  Download
                </button>
              </div><!-- /.col-6 -->
            </div><!-- /.row -->
          </div><!-- /.container -->
        </div><!-- /.o-modal-footer -->
      </div><!-- /.o-modal-content -->
    </div><!-- /.o-modal -->
    <FolderPicker v-if="$store.state.multivariate.pickFolder" />
  </div><!-- /#previewClusters -->
</template>

<script>
import FolderPicker from './FolderPicker.vue'
const turf = require('@turf/turf')

export default {
  components: {
    FolderPicker
  },
  mounted () {
    console.log('Loading Map')
    this.initMap()
  },
  computed: {
    mapObject: {
      get () {
        return this.$store.state.multivariate.mapObject
      },
      set (value) {
        this.$store.commit('multivariate/setStateProperty', { property: 'mapObject', value: value })
      }
    }
  },
  methods: {
    download () {
      // Download for now
      var a = document.createElement('a')
      a.href = URL.createObjectURL(
        new Blob([JSON.stringify(this.$store.state.multivariate.clusteredGeoJson)], { type: 'application/json' })
      )
      a.download = 'kmeansZones.geojson'
      a.click()
    },
    closeClusterPreview () {
      setTimeout(() => {
        this.$store.commit('multivariate/joinDatasets')
      }, 300)
      this.$store.commit('multivariate/setStateProperty', { property: 'previewClusters', value: false })
    },
    initMap () {
      mapboxgl.accessToken = 'pk.eyJ1IjoibGVyZ3AiLCJhIjoiY2p4bmI1NzNzMGN0MTNjcGx4cjF4eDBtdSJ9.2C0FEHhNZ-jGd7jgIRTrEQ' // eslint-disable-line
      this.mapObject = new mapboxgl.Map({ // eslint-disable-line
        container: 'map',
        style: 'mapbox://styles/mapbox/satellite-v9',
        center: [-95, 40],
        zoom: 3
      })
      this.mapObject.on('load', () => {
        this.mapDataset()
      }) // map.on load
    },
    mapDataset () {
      const mapObject = this.mapObject
      // Add GeoJSON dataset preview
      mapObject.addSource('datasetPreviewGeojson', {
        type: 'geojson',
        data: this.$store.state.multivariate.clusteredGeoJson
      })
      const circlePaint = { 'circle-radius': this.$store.state.multivariate.defaults.pointStops, 'circle-color': '#ffc107' }
      mapObject.addLayer({
        id: 'datasetPreview',
        type: 'circle',
        source: 'datasetPreviewGeojson',
        layout: {},
        paint: circlePaint
      })
      mapObject.fitBounds(turf.bbox(this.$store.state.multivariate.clusteredGeoJson), {
        animate: false,
        padding: 20
      })
      this.visualizeDataset()
    },
    visualizeDataset() {
      const mapObject = this.mapObject
      const colors =   [
        '#953c22',
        '#b65643',
        '#d67431',
        '#eea82d',
        '#fbe735',
        '#7ce92c',
        '#23ce34',
        '#27a57e',
        '#1f738c',
        '#1a3462',
        '#000018'
      ]
      const color = [
        'match',
        ['get', 'cluster']
      ]
      for (let i = 0; i < this.$store.state.multivariate.zoneCount; i++) {
        color.push(i)
        const colorIndex = Math.floor((colors.length / this.$store.state.multivariate.zoneCount) * i)
        console.log(colorIndex)
        color.push(colors[colorIndex])
      }
      color.push('#333')
      mapObject.setPaintProperty('datasetPreview', 'circle-color', color)
    }
  }
}
</script>

<style scoped>
/* Scoped — the legacy plugin's unscoped #map rule was leaking out
   and pushing the core farm map (also id="map") down 50px, leaving
   a black band above it. */
#map {
  position: absolute;
  top: 50px;
  left: 0;
  width: 100%;
  height: calc(100% - 100px);
}
</style>
